import VueI18n from 'vue-i18n'
import el from '@/locale/el'
import en from '@/locale/en'
import Vue from 'vue'

const messages = { el, en }
Vue.use(VueI18n)

export default new VueI18n({
    locale: 'el', messages
})